export default "__VITE_ASSET__DDoMZl3O__"